import debounce from 'lodash/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { toggleFilter } from '../actions/filtersActions';
import FilterItem from '../components/FilterItem';

function FilterItemContainer(props) {
    const dispatch = useDispatch();
    const activeFilters = useSelector(state => state.filters.activeFilters);

    const filterClick = debounce(() => {
        dispatch(toggleFilter(props));
    }, 250, {
        leading: true,
        trailing: false
    });

    return (
        <FilterItem
            {...props}
            activeFilters={activeFilters}
            filterClick={filterClick}
        />
    );
}

export default FilterItemContainer;
